// extracted by mini-css-extract-plugin
export default {"rotateQuote":"OHA9kH","mirrorQuote":"uO34xH"};